"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaCheckoutButton = require("../../apis/bwa/widgets/bwa-checkout-button");
var _cart = require("../../apis/shopify/cart");
var _utils = require("../../utils/utils");
var _constants = require("../../constants/constants");
var _fetchPromise = require("../../apis/bwa/fetch-promise");
var _checkoutRedirectHandler = require("../../utils/checkout-redirect-handler");
var _bwaRedirectInfoWidget = _interopRequireDefault(require("../bwa-redirect-info-widget/bwa-redirect-info-widget"));
var _gaClientIdManager = require("../../utils/ga-client-id-manager");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwACheckoutButtonRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwACheckoutButtonRenderHandler() {
    var _this;
    (0, _classCallCheck2["default"])(this, BwACheckoutButtonRenderHandler);
    _this = _callSuper(this, BwACheckoutButtonRenderHandler);
    _this.storeId = window.storeId;
    _this.storeUrl = window.location.origin;
    _this.pre.push(function () {
      var _window$isMandateChec, _window$bwaValidateSt;
      _this.config = window.bwaMerchantConfig.bwaCheckoutButton;
      _this.checkoutButtonSelectors = _this.config.checkoutButtonSelectors;
      _this.bwaCheckoutButtonIframeIds = ['bwa-checkout-address-fill-selection-widget'];
      _this.bwaCheckoutAddressFillSelectionWidgetId = 'bwa-checkout-address-fill-selection-widget';
      _this.bwaCheckoutAddressFillSelectionWidgetCssClass = 'bwa-checkout-address-fill-selection-widget';
      _this.checkoutButtonWithAddressPrefillId = "#bwa-checkout-button-address-prefill-widget";
      _this.isBwACart = false;
      _this.isMandateCheckoutEnabled = (_window$isMandateChec = window.isMandateCheckoutEnabled) !== null && _window$isMandateChec !== void 0 ? _window$isMandateChec : true;
      _this.isStoreBwAEnabled = (_window$bwaValidateSt = window.bwaValidateStoreResponse) === null || _window$bwaValidateSt === void 0 ? void 0 : _window$bwaValidateSt.isStoreBwAEnabled;
    });
    return _this;
  }
  (0, _inherits2["default"])(BwACheckoutButtonRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwACheckoutButtonRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;
        var _this$redirectInfoWid, _this$redirectInfoWid2, enableBtns;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupEventListeners();
              if (this.isMandateCheckoutEnabled && (0, _utils.getRtoTreatment)() !== _constants.TREATMENTS.CONTROL && this.isStoreBwAEnabled && (0, _utils.isCheckoutOfferingActive)()) {
                this.disableCheckoutButtons();
                this.redirectInfoWidget = new _bwaRedirectInfoWidget["default"]({
                  buttonSelector: this.checkoutButtonSelectors,
                  useMutationObserver: true,
                  isHidden: true
                });
                enableBtns = function enableBtns() {
                  return _this2.enableCheckoutButtons();
                };
                (_this$redirectInfoWid = this.redirectInfoWidget.renderHandler.iframeResolved) === null || _this$redirectInfoWid === void 0 || _this$redirectInfoWid.then(enableBtns);
                setTimeout(enableBtns, 2000);
                (_this$redirectInfoWid2 = this.redirectInfoWidget.renderHandler) === null || _this$redirectInfoWid2 === void 0 || _this$redirectInfoWid2.applyRepeatCustomerVisibility();
              }
              _context.next = 4;
              return this.render();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.RESOLVE_CHECKOUT_OPTIONS));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "disableCheckoutButtons",
    value: function disableCheckoutButtons() {
      (0, _utils.safeQuerySelectorAll)(this.checkoutButtonSelectors).forEach(function (btn) {
        btn.disabled = true;
        btn.classList.add('checkout-button--disabled');
      });
    }
  }, {
    key: "enableCheckoutButtons",
    value: function enableCheckoutButtons() {
      (0, _utils.safeQuerySelectorAll)(this.checkoutButtonSelectors).forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('checkout-button--disabled');
      });
    }
  }, {
    key: "computePromiseFlags",
    value: function computePromiseFlags(skuAvailabilityList) {
      if (!skuAvailabilityList || (0, _typeof2["default"])(skuAvailabilityList) !== "object") {
        console.error("[BwA] Invalid skuAvailabilityList format:", skuAvailabilityList);
        return {
          promiseOnlyBwA: false
        };
      }
      var isInStockList = Object.values(skuAvailabilityList).map(function (item) {
        return item.inStock;
      });
      var promiseOnlyBwA = isInStockList.includes(true);
      return {
        promiseOnlyBwA: promiseOnlyBwA
      };
    }
  }, {
    key: "generateSkuDetailList",
    value: function generateSkuDetailList(cartItems) {
      var bwaItems = cartItems;
      if (!Array.isArray(bwaItems)) {
        return [];
      }
      return bwaItems.map(function (item) {
        return {
          ecpSkuId: item.variant_id,
          itemId: item.variant_id,
          quantity: item.quantity
        };
      });
    }
  }, {
    key: "resolveCheckoutOptions",
    value: function () {
      var _resolveCheckoutOptions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(cartItems) {
        var hasBwASku, skuDetailList, fetchPromiseData, _this$computePromiseF, promiseOnlyBwA;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isMandateCheckoutEnabled) {
                this.disableCheckoutButtons();
              }
              skuDetailList = this.generateSkuDetailList(cartItems);
              _context3.next = 4;
              return (0, _fetchPromise.fetchPromiseV2)(this.storeId, skuDetailList);
            case 4:
              fetchPromiseData = _context3.sent;
              if (fetchPromiseData) {
                _context3.next = 9;
                break;
              }
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CLEAR_DELIVERY_PILLS));
              if (!this.isMandateCheckoutEnabled) {
                this.enableCheckoutButtons();
              }
              return _context3.abrupt("return");
            case 9:
              sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.SKU_AVAILABILITY_DATA, JSON.stringify(fetchPromiseData));
              hasBwASku = Object.values((fetchPromiseData === null || fetchPromiseData === void 0 ? void 0 : fetchPromiseData.skuAvailabilityList) || {}).some(function (sku) {
                return (sku === null || sku === void 0 ? void 0 : sku.isBuyable) === true;
              });
              if (hasBwASku) window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.SETUP_RETRY_UPDATE_DELIVERY_PILL, {
                detail: {
                  cartItems: cartItems
                }
              }));
              // Fired for every cohort, including `bwa_checkout_none` (bwaOfferings.CHECKOUT = false), so the
              // cart step is comparable across cohorts. Consumers segment on the exp_bwa_experience event
              // parameter rather than on the event's presence.
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_CART_LOADED));
              if (!this.isMandateCheckoutEnabled) {
                _this$computePromiseF = this.computePromiseFlags(fetchPromiseData.skuAvailabilityList), promiseOnlyBwA = _this$computePromiseF.promiseOnlyBwA;
                this.isBwACart = promiseOnlyBwA && hasBwASku;
                this.enableCheckoutButtons();
              }
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.UPDATE_DELIVERY_PILL));
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function resolveCheckoutOptions(_x) {
        return _resolveCheckoutOptions.apply(this, arguments);
      }
      return resolveCheckoutOptions;
    }()
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this3 = this;
      if (!this.isMandateCheckoutEnabled) {
        _checkoutRedirectHandler.CheckoutRedirectHandler.setupMessageListener({
          expectedButtonType: _constants.SESSION_STORAGE_VALUES.CHECKOUT_BUTTON,
          buttonName: _constants.BUTTON_NAMES.CHECKOUT,
          checkoutButtonWithAddressPrefillId: this.checkoutButtonWithAddressPrefillId,
          storeUrl: this.storeUrl,
          storeId: this.storeId,
          bwaCheckoutButtonIframeIds: this.bwaCheckoutButtonIframeIds,
          getCartDetails: function () {
            var _getCartDetails = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
              var cart;
              return _regenerator["default"].wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return (0, _cart.fetchCart)();
                  case 2:
                    cart = _context4.sent;
                    return _context4.abrupt("return", cart.items.map(function (item) {
                      return {
                        variantId: item.variant_id,
                        quantity: item.quantity
                      };
                    }));
                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            function getCartDetails() {
              return _getCartDetails.apply(this, arguments);
            }
            return getCartDetails;
          }(),
          hideCheckoutAddressSelectionDialog: function hideCheckoutAddressSelectionDialog() {
            return _this3.hideCheckoutAddressSelectionDialog();
          }
        });
      }
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.RESOLVE_CHECKOUT_OPTIONS, /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var cart, cartItems;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _cart.fetchCart)();
            case 3:
              cart = _context5.sent;
              cartItems = cart.items;
              _context5.next = 7;
              return _this3.resolveCheckoutOptions(cartItems);
            case 7:
              _context5.next = 13;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              console.error('[BwA] Error resolving checkout options:', _context5.t0);
              // Fail open: never leave the native buttons stuck disabled if resolution errors out.
              _this3.enableCheckoutButtons();
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 9]]);
      })));
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.CART_UPDATED, /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this3.render();
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })));
      document.addEventListener('click', this.handleNativeCheckoutButtonSubmit.bind(this), true);
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === _constants.EVENT_TYPE.CUSTOM.BWA_ADD_ADDRESS_CHECKOUT_BLOCK_RENDER) {
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_ADD_ADDRESS_CHECKOUT_BLOCK_RENDER));
        }
      });
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          _this3.enableCheckoutButtons();
        }
      });
      this.setupQuickCheckoutDismissListener();
    }
  }, {
    key: "setupQuickCheckoutDismissListener",
    value: function setupQuickCheckoutDismissListener() {
      var _this4 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS, function () {
        _this4.enableCheckoutButtons();
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_DISMISS, function () {
        _this4.enableCheckoutButtons();
      });
    }
  }, {
    key: "handleNativeCheckoutButtonSubmit",
    value: function handleNativeCheckoutButtonSubmit() {
      var _this$checkoutButtonS;
      if (!((_this$checkoutButtonS = this.checkoutButtonSelectors) !== null && _this$checkoutButtonS !== void 0 && _this$checkoutButtonS.trim())) return;
      var button = event.target.closest(this.checkoutButtonSelectors);
      if (button && (this.isMandateCheckoutEnabled || this.isBwACart)) {
        // Reported for every cohort before deciding whether BwA takes the click over. This is a
        // click on the MERCHANT's own checkout button, which behaves identically whichever
        // cohort the shopper is in, so gating the event made those cohorts unmeasurable rather
        // than describing anything real. Consumers segment on exp_bwa_experience /
        // exp_bwa_rto_checkout, both already on the payload via getExperimentContext().
        window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.CLICK_NATIVE_CHECKOUT_BUTTON));

        // bwaOfferings.CHECKOUT = false (`bwa_checkout_none`) and RTO CONTROL both mean BwA
        // must leave the click alone: return without touching the event so the merchant's
        // native checkout proceeds, and without setting LAST_CLICKED_BUTTON_TYPE, which would
        // pull the shopper into the BwA redirect flow.
        if (!(0, _utils.isCheckoutOfferingActive)()) {
          return;
        }
        if (this.isMandateCheckoutEnabled && (0, _utils.getRtoTreatment)() === _constants.TREATMENTS.CONTROL) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.LAST_CLICKED_BUTTON_TYPE, _constants.SESSION_STORAGE_VALUES.CHECKOUT_BUTTON);
        if (this.isMandateCheckoutEnabled) {
          if ((0, _utils.isEmbeddedCheckoutEnabled)()) {
            // Embedded checkout: create the cart up front via the same-origin redirect-info
            // iframe, build the /checkout-page URL at the ECP with the returnUrl, and open it
            // in the overlay. Takes priority over the repeat-CX sheet.
            this.triggerEmbeddedCheckout();
          } else if ((0, _utils.isBwARepeatCustomer)()) {
            (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.QC_BUTTON_CLICKED);
            this.triggerQuickCheckout();
          } else {
            (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.MANDATE_BUTTON_CLICKED);
            this.triggerMandateCheckout();
          }
        } else {
          this.injectCheckoutAddressFillSelectionWidget();
        }
      }
    }
  }, {
    key: "triggerQuickCheckout",
    value: function () {
      var _triggerQuickCheckout = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var cart, items;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.disableCheckoutButtons();
              _context7.prev = 1;
              _context7.next = 4;
              return (0, _cart.fetchCart)();
            case 4:
              cart = _context7.sent;
              items = cart.items.map(function (item) {
                return "".concat(item.variant_id, ":").concat(item.quantity);
              }).join(',');
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_TRIGGER, {
                detail: {
                  items: items,
                  gaClientId: _gaClientIdManager.GaClientIdManager.getGaClientId() || '',
                  ecpSessionId: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID) || '',
                  ecpCustomerId: _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID
                }
              }));
              _context7.next = 12;
              break;
            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](1);
              this.enableCheckoutButtons();
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 9]]);
      }));
      function triggerQuickCheckout() {
        return _triggerQuickCheckout.apply(this, arguments);
      }
      return triggerQuickCheckout;
    }()
  }, {
    key: "triggerMandateCheckout",
    value: function () {
      var _triggerMandateCheckout = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var _this5 = this;
        var cart, cartDetails;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.disableCheckoutButtons();
              _context8.next = 3;
              return (0, _cart.fetchCart)();
            case 3:
              cart = _context8.sent;
              cartDetails = cart.items.map(function (item) {
                return {
                  variantId: item.variant_id,
                  quantity: item.quantity
                };
              });
              this.redirectInfoWidget.renderHandler.setOnCheckoutFailed(function () {
                _this5.enableCheckoutButtons();
              });
              _context8.next = 8;
              return this.redirectInfoWidget.renderHandler.sendCheckoutMessage({
                cartDetails: cartDetails,
                storeUrl: this.storeUrl,
                storeId: this.storeId,
                buttonId: this.checkoutButtonWithAddressPrefillId
              });
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function triggerMandateCheckout() {
        return _triggerMandateCheckout.apply(this, arguments);
      }
      return triggerMandateCheckout;
    }()
  }, {
    key: "triggerEmbeddedCheckout",
    value: function () {
      var _triggerEmbeddedCheckout = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var cart, cartDetails, _yield$this$redirectI, checkoutId, returnUrl, url;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.disableCheckoutButtons();
              _context9.prev = 1;
              _context9.next = 4;
              return (0, _cart.fetchCart)();
            case 4:
              cart = _context9.sent;
              cartDetails = cart.items.map(function (item) {
                return {
                  variantId: item.variant_id,
                  quantity: item.quantity
                };
              }); // Create the cart up front (same-origin iframe) so /checkout-page can load cart + address
              // in parallel; resolves with the checkoutId and the ECP returnUrl to resume on completion.
              _context9.next = 8;
              return this.redirectInfoWidget.renderHandler.triggerCartCreation({
                cartDetails: cartDetails,
                storeUrl: this.storeUrl,
                storeId: this.storeId
              });
            case 8:
              _yield$this$redirectI = _context9.sent;
              checkoutId = _yield$this$redirectI.checkoutId;
              returnUrl = _yield$this$redirectI.returnUrl;
              url = ((0, _utils.isCognitoLoginEnabled)() ? _utils.buildCheckoutLoaderUrl : _utils.buildCheckoutPageUrl)({
                checkoutId: checkoutId,
                returnUrl: returnUrl,
                ecpCustomerId: _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID,
                ecpSessionId: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID) || ''
              });
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_TRIGGER, {
                detail: {
                  url: url
                }
              }));
              _context9.next = 18;
              break;
            case 15:
              _context9.prev = 15;
              _context9.t0 = _context9["catch"](1);
              this.enableCheckoutButtons();
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 15]]);
      }));
      function triggerEmbeddedCheckout() {
        return _triggerEmbeddedCheckout.apply(this, arguments);
      }
      return triggerEmbeddedCheckout;
    }()
  }, {
    key: "injectCheckoutAddressFillSelectionWidget",
    value: function injectCheckoutAddressFillSelectionWidget() {
      var _this6 = this;
      var modalContainer = document.createElement("div");
      modalContainer.id = 'bwa-checkout-address-fill-selection-container';
      modalContainer.className = 'bwa-checkout-address-fill-selection-container-modal';
      var iframe = (0, _bwaCheckoutButton.checkoutAddressFillSelectionWidget)(this.bwaCheckoutAddressFillSelectionWidgetId, this.bwaCheckoutAddressFillSelectionWidgetCssClass);
      modalContainer.appendChild(iframe);
      document.body.insertBefore(modalContainer, document.body.firstChild);
      modalContainer.classList.add('active');
      modalContainer.addEventListener('click', function (event) {
        if (event.target === modalContainer) {
          _this6.hideCheckoutAddressSelectionDialog();
        }
      });
    }
  }, {
    key: "hideCheckoutAddressSelectionDialog",
    value: function hideCheckoutAddressSelectionDialog() {
      var container = (0, _utils.safeGetElementById)('bwa-checkout-address-fill-selection-container');
      if (container) {
        container.remove();
      }
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-checkout-button-render-handler.js.map
